import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

//https://developer.trimblemaps.com/maps-sdk/api

/* global customElements, ALKMaps, TrimbleMaps, TrimbleMapsControl */
class MapPanel extends BaseComponent {

	static get properties() {
		return {			
			style: {type: String},
			mapContainerId: {type: String},
			singleSearch: {type: Boolean},
			addTruckRestrictions: {type: Boolean},
			addTruckRestrictionsFilter: {type: Boolean},
			delayInit: {type: Number}
		};
	}
	
	constructor() {
		super();
		
		var mapPanel = this;	
		mapPanel.style = '';
		mapPanel.mapContainerId = 'mapInternalId';
		mapPanel.delayInit = 0;
		
		//our license Doesn't support this currently (we get 401- unauthorized)
		mapPanel.addTruckRestrictions = false;
		mapPanel.addTruckRestrictionsFilter = false;
		mapPanel.singleSearch = false;
				
		setTimeout(function(){
			mapPanel.init();
		}, mapPanel.delayInit);
	}
	
	createRenderRoot() {
		return this;
	}
	
	render() {	
		return html`
			<style>				
			</style>
			<div id="${this.mapContainerId}" style="${this.style}"></div>
		`;
	}
	
	init() {
		var mapPanel = this;
		
		TrimbleMaps.APIKey = "B7393E2ECEBC6342900325047C25EBD0";

		//var container = ElementUtil.query(mapPanel, 'mapInternalId');

		var addNavControls = function() {
			mapPanel.map.addControl(new TrimbleMaps.NavigationControl());
		};

		var addScale = function() {
			const scale = new TrimbleMaps.ScaleControl({
				maxWidth: 80,
				unit: 'imperial'
			});
			mapPanel.map.addControl(scale);
		};
		
		var addFullscreen = function() {
			mapPanel.map.addControl(new TrimbleMaps.FullscreenControl());			
		};
		
		var addSingleSearch = function() {
			if (mapPanel.singleSearch) {
				var searchCtrl = new TrimbleMapsControl.SingleSearch({
				  placeholderText: "Search here",
				  doneTypingInterval: 700,
				  hideResults: true,
				  locationRelevance: "mapCenter",
				  searchOption: {
					region: TrimbleMaps.Common.Region.WW,
					maxResults: 30
				  },
				  markerStyle: {},
				  markerConfig: {},
				  popupConfig: {}
				  // Include other optional customization options
				});

				mapPanel.map.addControl(searchCtrl, "top-left");			
			}
		};

		//init map
		
		mapPanel.map = new TrimbleMaps.Map({
			container: mapPanel.mapContainerId,
			center: new TrimbleMaps.LngLat(-98.5, 38.8),
			zoom: 3
		});
		addNavControls();
		addScale();
		addFullscreen();
		addSingleSearch();
		mapPanel.initStateToLatLong();
		
		//if map is hidden or size change it the map needs to be resized
		const resizeObserver = new ResizeObserver(entries => {
			mapPanel.map.resize();
		});

		resizeObserver.observe(mapPanel.querySelector('#' + mapPanel.mapContainerId));		
				
					
		//fire ready event
		if (mapPanel.addTruckRestrictions) {
			mapPanel.truckRestriction = new TrimbleMaps.TruckRestriction();
		}
		
		mapPanel.map.on('load', function (e) {
			
			if (mapPanel.truckRestriction) {
				mapPanel.truckRestriction.addTo(mapPanel.map);
				
				mapPanel.map.on('truckrestriction', () => {
					mapPanel.truckRestriction.setVisibility(true);
					
					var truckRestrictionCtrl = new TrimbleMaps.TruckRestrictionClickControl();
					mapPanel.map.addControl(truckRestrictionCtrl);
					
					if (mapPanel.addTruckRestrictionsFilter) {
						var ctrlFilter = new TrimbleMaps.TruckRestrictionFilterControl();
						mapPanel.map.addControl(ctrlFilter);
						ctrlFilter.Filter();
					}
					
				});
			}
			
			var readyEvent = new CustomEvent('ready', { detail: mapPanel });
			mapPanel.dispatchEvent(readyEvent);	
		});		

		
	}
	
	translateRoutingOptions(routeOption, optionType) {
		var mapPanel = this;
		
		var optionType = optionType || 'GPS';
		
		//translate to mapping restrictions
		var mapRouteOptions = {
			bordersOpen: routeOption.routeOptions[optionType].options['BORDERS_OPEN'],
			overrideRestrict: routeOption.routeOptions[optionType].options['OVERRIDE_RESTRICT'],
			highwayOnly: routeOption.routeOptions[optionType].options['HIGHWAY_ONLY']			
		};
		
		var vehicleType = routeOption.routeOptions[optionType].options['VEHICLE_TYPE'];
		if (vehicleType) {
			if (vehicleType === 'TRUCK') {
				mapRouteOptions.vehicleType = TrimbleMaps.Common.VehicleType.TRUCK;				
			} else if (vehicleType === 'LTRUCK') {
				mapRouteOptions.vehicleType = TrimbleMaps.Common.VehicleType.LIGHT_TRUCK;				
			} else if (vehicleType === 'AUTOMOBILE') {
				mapRouteOptions.vehicleType = TrimbleMaps.Common.VehicleType.AUTOMOBILE;				
			} 	
		}
		
		var routeType = routeOption.routeOptions[optionType].options['ROUTING_TYPE'];
		if (routeType) {
			if (routeType === 'Shortest' || routeType === 'SHT') {
				mapRouteOptions.routeType = TrimbleMaps.Common.RouteType.SHORTEST;
			} else if (routeType === 'Fastest' || routeType === 'FAS') {
				mapRouteOptions.routeType = TrimbleMaps.Common.RouteType.FASTEST;
			} else {
				mapRouteOptions.routeType = TrimbleMaps.Common.RouteType.PRACTICAL;
			}
		}
		
		var hazMatType = routeOption.routeOptions[optionType].options['HAZMATYPE'];
		if (hazMatType && hazMatType !== 'N') {
			var hazMatTypes = [];
			if (hazMatType === 'G') {			
				hazMatTypes.push(TrimbleMaps.Common.HazMatType.GENERAL);
			} else if (hazMatType === 'C') {	
				hazMatTypes.push(TrimbleMaps.Common.HazMatType.CAUSTIC);
			} else if (hazMatType === 'E') {	
				hazMatTypes.push(TrimbleMaps.Common.HazMatType.EXPLOSIVES);
			} else if (hazMatType === 'F') {	
				hazMatTypes.push(TrimbleMaps.Common.HazMatType.FLAMMABLE);
			} else if (hazMatType === 'I') {	
				hazMatTypes.push(TrimbleMaps.Common.HazMatType.INHALANTS);
			} else if (hazMatType === 'R') {	
				hazMatTypes.push(TrimbleMaps.Common.HazMatType.RADIOACTIVE);
			}
			mapRouteOptions.hazMatType = hazMatTypes;
		}
		
		var tollAvoidance = routeOption.routeOptions[optionType].options['TOLL_ROADS'];
		if (tollAvoidance) {
			if (tollAvoidance === 'USE') {
				mapRouteOptions.tollDiscourage = false;				
			} else if (tollAvoidance === 'AVOIDA') {
				mapRouteOptions.tollDiscourage = true;
			} else if (tollAvoidance === 'AVOIDP') {
				mapRouteOptions.tollDiscourage = true;
			}
		} 
		
		if (routeOption.version !== 'Current') {
			mapRouteOptions.version = routeOption.version;
		}
		return mapRouteOptions;
	}	

	centerOnUSA() {
		var mapPanel = this;
		mapPanel.centerOnPoint({
            latitude: 38.8,
            longitude: -98.5
        }, 3);
	}
	
	togglePOILocations() {
		var mapPanel = this;
		mapPanel.map.togglePOIVisibility();
	}
	
	togglePlaces() {
		var mapPanel = this;
		mapPanel.map.togglePlacesVisibility();
	}	
	
	toggle3dBuildings() {
		var mapPanel = this;
		mapPanel.map.toggle3dBuildingVisibility();
	}
		
	toggleTruckRestriction() {
		var mapPanel = this;
		
		//only if  available
		if (mapPanel.truckRestriction) {
			mapPanel.truckRestriction.toggleVisibility();
		}
	}		
		
	showSatellite() {
		var mapPanel = this;
		mapPanel.map.setStyle(TrimbleMaps.Common.Style.SATELLITE);
	}	
	
	showTransportation() {
		var mapPanel = this;
		mapPanel.map.setStyle(TrimbleMaps.Common.Style.TRANSPORTATION);
	}
	
	showTerrain() {
		var mapPanel = this;
		mapPanel.map.setStyle(TrimbleMaps.Common.Style.TERRAIN);
	}	
	
	/**
	 * 
	 * @param {type} longLat (array [30.5, 50.5])  (
	 * @param {type} options
	 *  popupHTML
	 *  element
	 *  anchor
	 *  offset
	 *  color
	 *  scale 
	 *  draggable
	 *  rotation
	 *  pitchAlignment
	 *  rotationAlignment  
	 *    
	 * @returns marker;
	 */
	addMarker(longLat, options) {		
		var mapPanel = this;
		options = options || {};		
		
		var marker = new TrimbleMaps.Marker(options)			
			.setLngLat(longLat)
			.addTo(mapPanel.map);
		marker.markerId = ElementUtil.nextId();
		
		if (options.popupHTML) {
			marker.setPopup(new TrimbleMaps.Popup().setHTML(options.popupHTML));
		}
		mapPanel.markers = mapPanel.markers || [];		
		mapPanel.markers.push(marker);
		
		return marker;
	}
	
	removeMarker(marker) {
		var mapPanel = this;
		
		marker.remove();
		
		var keep = [];
		mapPanel.markers.forEach(function(m){
			if (marker.markerId !== m.markerId) {
				keep.push(m);
			}
		});
		mapPanel.markers = keep;
	}
	
	createPopup(html, longLat, options) {
		var mapPanel = this;
		
		var popup = new TrimbleMaps.Popup(options)
			.setLngLat(longLat)
			.setHTML(html)
			.addTo(mapPanel.map);
		return popup;
	}	
		
	centerOnPoint(longLat) {
		var mapPanel = this;		
		mapPanel.map.setCenter(longLat);                
	}
	
	zoomOnPoint(centerPoint, zoomLevel) {
		var mapPanel = this;
		mapPanel.map.flyTo({
			center: centerPoint,
			zoom: zoomLevel ? zoomLevel : 12
		});
	}
		
	panTo(longLat) {
		var mapPanel = this;
		mapPanel.map.panTo(longLat);
	}
		
	route(routeModel) {
		var mapPanel = this;
		
		routeModel.routeOption = routeModel.routeOption || {};
		
		var request = routeModel.routeOption;
		request.routeId =  routeModel.routeId;
		
		request.stops = [];
		routeModel.stops.forEach(function(stop){
			request.stops.push(new TrimbleMaps.LngLat(stop.longitude, stop.latitude));
		});
		
		var route = new TrimbleMaps.Route(request);	
		route.addTo(mapPanel.map);
		return route;
	}	
	
	initStateToLatLong() {
		var mapPanel = this;		
		mapPanel.stateToCountryMap = {};
		
		mapPanel.stateToCountryMap['AK_USA'] = {lat: 61.3850, long:-152.2683};
		mapPanel.stateToCountryMap['AL_USA'] = {lat: 32.7990, long:-86.8073};
		mapPanel.stateToCountryMap['AR_USA'] = {lat: 34.9513, long:-92.3809};
		mapPanel.stateToCountryMap['AS_USA'] = {lat: 14.2417, long:-170.7197};
		mapPanel.stateToCountryMap['AZ_USA'] = {lat: 33.7712, long:-111.3877};
		mapPanel.stateToCountryMap['CA_USA'] = {lat: 36.1700, long:-119.7462};
		mapPanel.stateToCountryMap['CO_USA'] = {lat: 39.0646, long:-105.3272};
		mapPanel.stateToCountryMap['CT_USA'] = {lat: 41.5834, long:-72.7622};
		mapPanel.stateToCountryMap['DC_USA'] = {lat: 38.8964, long:-77.0262};
		mapPanel.stateToCountryMap['DE_USA'] = {lat: 39.3498, long:-75.5148};
		mapPanel.stateToCountryMap['FL_USA'] = {lat: 27.8333, long:-81.7170};
		mapPanel.stateToCountryMap['GA_USA'] = {lat: 32.9866, long:-83.6487};
		mapPanel.stateToCountryMap['HI_USA'] = {lat: 21.1098, long:-157.5311};
		mapPanel.stateToCountryMap['IA_USA'] = {lat: 42.0046, long:-93.2140};
		mapPanel.stateToCountryMap['ID_USA'] = {lat: 44.2394, long:-114.5103};
		mapPanel.stateToCountryMap['IL_USA'] = {lat: 40.3363, long:-89.0022};
		mapPanel.stateToCountryMap['IN_USA'] = {lat: 39.8647, long:-86.2604};
		mapPanel.stateToCountryMap['KS_USA'] = {lat: 38.5111, long:-96.8005};
		mapPanel.stateToCountryMap['KY_USA'] = {lat: 37.6690, long:-84.6514};
		mapPanel.stateToCountryMap['LA_USA'] = {lat: 31.1801, long:-91.8749};
		mapPanel.stateToCountryMap['MA_USA'] = {lat: 42.2373, long:-71.5314};
		mapPanel.stateToCountryMap['MD_USA'] = {lat: 39.0724, long:-76.7902};
		mapPanel.stateToCountryMap['ME_USA'] = {lat: 44.6074, long:-69.3977};
		mapPanel.stateToCountryMap['MI_USA'] = {lat: 43.3504, long:-84.5603};
		mapPanel.stateToCountryMap['MN_USA'] = {lat: 45.7326, long:-93.9196};
		mapPanel.stateToCountryMap['MO_USA'] = {lat: 38.4623, long:-92.3020};
		mapPanel.stateToCountryMap['MP_USA'] = {lat: 14.8058, long:145.5505};
		mapPanel.stateToCountryMap['MS_USA'] = {lat: 32.7673, long:-89.6812};
		mapPanel.stateToCountryMap['MT_USA'] = {lat: 46.9048, long:-110.3261};
		mapPanel.stateToCountryMap['NC_USA'] = {lat: 35.6411, long:-79.8431};
		mapPanel.stateToCountryMap['ND_USA'] = {lat: 47.5362, long:-99.7930};
		mapPanel.stateToCountryMap['NE_USA'] = {lat: 41.1289, long:-98.2883};
		mapPanel.stateToCountryMap['NH_USA'] = {lat: 43.4108, long:-71.5653};
		mapPanel.stateToCountryMap['NJ_USA'] = {lat: 40.3140, long:-74.5089};
		mapPanel.stateToCountryMap['NM_USA'] = {lat: 34.8375, long:-106.2371};
		mapPanel.stateToCountryMap['NV_USA'] = {lat: 38.4199, long:-117.1219};
		mapPanel.stateToCountryMap['NY_USA'] = {lat: 42.1497, long:-74.9384};
		mapPanel.stateToCountryMap['OH_USA'] = {lat: 40.3736, long:-82.7755};
		mapPanel.stateToCountryMap['OK_USA'] = {lat: 35.5376, long:-96.9247};
		mapPanel.stateToCountryMap['OR_USA'] = {lat: 44.5672, long:-122.1269};
		mapPanel.stateToCountryMap['PA_USA'] = {lat: 40.5773, long:-77.2640};
		mapPanel.stateToCountryMap['PR_USA'] = {lat: 18.2766, long:-66.3350};
		mapPanel.stateToCountryMap['RI_USA'] = {lat: 41.6772, long:-71.5101};
		mapPanel.stateToCountryMap['SC_USA'] = {lat: 33.8191, long:-80.9066};
		mapPanel.stateToCountryMap['SD_USA'] = {lat: 44.2853, long:-99.4632};
		mapPanel.stateToCountryMap['TN_USA'] = {lat: 35.7449, long:-86.7489};
		mapPanel.stateToCountryMap['TX_USA'] = {lat: 31.1060, long:-97.6475};
		mapPanel.stateToCountryMap['UT_USA'] = {lat: 40.1135, long:-111.8535};
		mapPanel.stateToCountryMap['VA_USA'] = {lat: 37.7680, long:-78.2057};
		mapPanel.stateToCountryMap['VI_USA'] = {lat: 18.0001, long:-64.8199};
		mapPanel.stateToCountryMap['VT_USA'] = {lat: 44.0407, long:-72.7093};
		mapPanel.stateToCountryMap['WA_USA'] = {lat: 47.3917, long:-121.5708};
		mapPanel.stateToCountryMap['WI_USA'] = {lat: 44.2563, long:-89.6385};
		mapPanel.stateToCountryMap['WV_USA'] = {lat: 38.4680, long:-80.9696};
		mapPanel.stateToCountryMap['WY_USA'] = {lat: 42.7475, long:-107.2085};
		mapPanel.stateToCountryMap['NS_CAN'] = {lat: 45.14574, long:-62.82288};
		mapPanel.stateToCountryMap['NU_CAN'] = {lat: 65.81267, long:-80.97584};
		mapPanel.stateToCountryMap['SK_CAN'] = {lat: 51.67363, long:-105.80185};
		mapPanel.stateToCountryMap['NL_CAN'] = {lat: 48.81445, long:-55.12407};
		mapPanel.stateToCountryMap['NB_CAN'] = {lat: 44.65487, long:-63.63454};
		mapPanel.stateToCountryMap['ON_CAN'] = {lat: 45.24894, long:-80.68115};
		mapPanel.stateToCountryMap['QC_CAN'] = {lat: 46.95492, long:-71.84202};
		mapPanel.stateToCountryMap['BC_CAN'] = {lat: 51.59819, long:-123.09412};
		mapPanel.stateToCountryMap['AB_CAN'] = {lat: 53.15311, long:-113.51905};
		mapPanel.stateToCountryMap['MB_CAN'] = {lat: 50.68390, long:-98.20767};
		mapPanel.stateToCountryMap['YT_CAN'] = {lat: 62.18819, long:-136.66259};
		mapPanel.stateToCountryMap['PE_CAN'] = {lat: 46.35863, long:-63.27328};
		mapPanel.stateToCountryMap['NT_CAN'] = {lat: 64.78407, long:-118.51008};
		mapPanel.stateToCountryMap['AG_MEX'] = {lat: 21.87945992, long:-102.2904135};
		mapPanel.stateToCountryMap['BJ_MEX'] = {lat: 30.76405113, long:-116.0092603};
		mapPanel.stateToCountryMap['BN_MEX'] = {lat: 30.76405113, long:-116.0092603};
		mapPanel.stateToCountryMap['BS_MEX'] = {lat: 26.01333335, long:-111.3516635};
		mapPanel.stateToCountryMap['CH_MEX'] = {lat: 26.93335472, long:-105.6666358};
		mapPanel.stateToCountryMap['CL_MEX'] = {lat: 18.92038129, long:-103.8799748};
		mapPanel.stateToCountryMap['CM_MEX'] = {lat: 18.65365928, long:-91.82448019};
		mapPanel.stateToCountryMap['CS_MEX'] = {lat: 16.74999697, long:-92.63337447};
		mapPanel.stateToCountryMap['CU_MEX'] = {lat: 28.32998781, long:-100.8499789};
		mapPanel.stateToCountryMap['DF_MEX'] = {lat: 19.44244244, long:-99.1309882};
		mapPanel.stateToCountryMap['DG_MEX'] = {lat: 25.57005292, long:-103.5000238};
		mapPanel.stateToCountryMap['GR_MEX'] = {lat: 17.54997398, long:-99.5000096};
		mapPanel.stateToCountryMap['GT_MEX'] = {lat: 20.67001609, long:-101.4999909};
		mapPanel.stateToCountryMap['HG_MEX'] = {lat: 20.17043418, long:-98.73003076};
		mapPanel.stateToCountryMap['JA_MEX'] = {lat: 19.77001935, long:-104.3699966};
		mapPanel.stateToCountryMap['MH_MEX'] = {lat: 19.67997316, long:-100.569996};
		mapPanel.stateToCountryMap['MR_MEX'] = {lat: 18.92110476, long:-99.23999964};
		mapPanel.stateToCountryMap['MX_MEX'] = {lat: 19.41001548, long:-99.02998661};
		mapPanel.stateToCountryMap['NA_MEX'] = {lat: 21.81999758, long:-105.2200481};
		mapPanel.stateToCountryMap['NX_MEX'] = {lat: 25.1899986, long:-99.83998885};
		mapPanel.stateToCountryMap['OA_MEX'] = {lat: 16.42999066, long:-95.01999882};
		mapPanel.stateToCountryMap['OT_MEX'] = {lat: 19.41001548, long:-99.02998661};
		mapPanel.stateToCountryMap['PU_MEX'] = {lat: 18.90002077, long:-98.44999618};
		mapPanel.stateToCountryMap['QR_MEX'] = {lat: 21.20839057, long:-86.7114549};
		mapPanel.stateToCountryMap['QT_MEX'] = {lat: 20.37998212, long:-100.0000308};
		mapPanel.stateToCountryMap['SI_MEX'] = {lat: 23.19999086, long:-106.2300381};
		mapPanel.stateToCountryMap['SL_MEX'] = {lat: 22.00001243, long:-99.66999923};
		mapPanel.stateToCountryMap['SO_MEX'] = {lat: 27.58000775, long:-109.9299931};
		mapPanel.stateToCountryMap['TB_MEX'] = {lat: 18.40002545, long:-93.22997888};
		mapPanel.stateToCountryMap['TL_MEX'] = {lat: 19.31999514, long:-98.2300096};
		mapPanel.stateToCountryMap['TM_MEX'] = {lat: 22.73335268, long:-98.95001734};
		mapPanel.stateToCountryMap['VE_MEX'] = {lat: 17.93997601, long:-94.73999007};
		mapPanel.stateToCountryMap['YU_MEX'] = {lat: 21.09998985, long:-89.27998743};
		mapPanel.stateToCountryMap['ZA_MEX'] = {lat: 22.35001691, long:-102.88001};
	}
	
	stateCountryToLatLong(state, country) {
		var mapPanel = this;
		if (!mapPanel.stateToCountryMap) {
			mapPanel.initStateToLatLong();
		}
		var latLong = mapPanel.stateToCountryMap[state.toUpperCase() + '_' + country.toUpperCase()];
		return latLong;
	}	
	
	
//Replace and Add as need 10-13-21 ...Right now it's not known what exactly is needed	
	
//	pinHighlightByLatLon(routeName, point, icon) {
//        var mapPanel = this;
//		
//        if (!mapPanel.routePins || !mapPanel.routePins[routeName] || !point) {
//            return;
//        }
//        lonLat = new ALKMaps.LonLat(point.lon, point.lat).transform(new ALKMaps.Projection("EPSG:4326"), mapPanel.map.getProjectionObject());
//
//        for (var name in mapPanel.routePins) {
//            if (mapPanel.routePins[name] && mapPanel.routePins[name].length > 0) {
//                for (var i = 1; mapPanel.routePins[name] && i < mapPanel.routePins[name].length - 1; i++) {
//                    var pinLonLat = mapPanel.routePins[name][i].lonlat;
//                    if (Math.abs(point.lat - pinLonLat.lat) < 1000 && Math.abs(point.lon - pinLonLat.lon) < 1000) {
//                        mapPanel.routePins[name][i].setUrl(icon);
//                        mapPanel.routePins[name][i].draw();
//                    }
//                }
//            }
//        }		
//	}
//	
//	pinHighlights(routeName, pinIndex, qty) {
//        var mapPanel = this;
//
//        // no route pins, and marker layer with markers, highlight marker, not route
//        if (mapPanel.markerLayer && mapPanel.markerLayer.markers && mapPanel.markerLayer.markers.length > 0) {
//            for (var i = pinIndex; i < (pinIndex + qty); i++) {
//                var marker = mapPanel.markerLayer.markers[i];
//                var r = marker.contentDiv.getElementsByTagName("rect")[0];
//                //change fill color
//                r.setAttribute("fill", "#0000FF");
//            }
//        }		
//	}
//	
//	pinHighlight(routeName, pinIndex, icon) {
//        var mapPanel = this;
//
//        // no route pins, and marker layer with markers, highlight marker, not route
//        if ((!mapPanel.routePins || !mapPanel.routePins[routeName] || mapPanel.routePins[routeName].length === 0) &&
//            (mapPanel.markerLayer && mapPanel.markerLayer.markers && mapPanel.markerLayer.markers.length > 0)) {
//            var marker = mapPanel.markerLayer.markers[pinIndex];
//            var r = marker.contentDiv.getElementsByTagName("rect")[0];
//            //change fill color
//            r.setAttribute("fill", "#0000FF");
//
//        }
//
//        if (pinIndex === 0 || !mapPanel.routePins || !mapPanel.routePins[routeName] || pinIndex >= mapPanel.routePins[routeName].length - 1) {
//            return;
//        }
//
//        if (mapPanel.routePins && mapPanel.routePins[routeName] && mapPanel.routePins[routeName].length > pinIndex) {
//            var lonLat = mapPanel.routePins[routeName][pinIndex].lonlat;
//
//            for (var i = 1; mapPanel.routePins && mapPanel.routePins[routeName] && i < mapPanel.routePins[routeName].length - 1; i++) {
//                var pinLonLat = mapPanel.routePins[routeName][i].lonlat;
//                if (Math.abs(lonLat.lat - pinLonLat.lat) < .001 && Math.abs(lonLat.lon - pinLonLat.lon) < .001) {
//                    mapPanel.routePins[routeName][i].setUrl(icon);
//                    mapPanel.routePins[routeName][i].draw();
//                }
//            }
//        }		
//	}
//	
//	removeHighlights(routeName) {
//        var mapPanel = this;
//
//        // no route pins, and marker layer with markers, highlight marker, not route
//        if ((!mapPanel.routePins || !mapPanel.routePins[routeName] || mapPanel.routePins[routeName].length === 0) &&
//            (mapPanel.markerLayer && mapPanel.markerLayer.markers && mapPanel.markerLayer.markers.length > 0)) {
//            for (var pinIndex = 0; pinIndex < mapPanel.markerLayer.markers.length; pinIndex++) {
//                var marker = mapPanel.markerLayer.markers[pinIndex];
//                
//                if(marker && marker.contentDiv) {
//                    var r = marker.contentDiv.getElementsByTagName("rect")[0];
//                    
//                    if(r) {
//                        //change fill color
//                        r.setAttribute("fill", "#FFA500");
//                    }
//                }
//            }
//
//        }
//
//        for (var name in mapPanel.routePins) {
//            for (var i = 1; mapPanel.routePins[name] && i < mapPanel.routePins[name].length - 1; i++) {
//                mapPanel.routePins[name][i].setUrl(mapPanel.commonIcon);
//                mapPanel.routePins[name][i].draw();
//            }
//        }		
//	}
//	
//	removeRoutes() {
//        var mapPanel = this;
//
//        if (mapPanel.routeLayer && mapPanel.routePins) {
//            for (var key in mapPanel.routePins) {
//                mapPanel.routeLayer.removeRoute(mapPanel.routePins[key]);
//            }
//        }
//        mapPanel.routePins = [];		
//	}
//	
//	setRoutingVisibility(visible) {
//		var mapPanel = this;
//
//        var routes = [];
//
//        for (var i = 0; mapPanel.routeLayer && mapPanel.routeLayer.routeHandleLookup && i < mapPanel.routeLayer.routeHandleLookup.length; i++) {
//            var routeName = mapPanel.routeLayer.routeHandleLookup[i].routeId;
//            mapPanel.routeLayer.setRouteVisibility(routeName, visible);
//
//            if (routes.indexOf(routeName) === -1) {
//                routes.push(routeName);
//            }
//        }
//
//        if (!mapPanel.routeLayer || routes.length === 0) {
//            alert('You do not have any routes on the map');
//            return;
//        }
//		mapPanel.routeLayer.setVisibility(visible);		
//	}
//	
//	getRoutingVisibility() {
//		var mapPanel = this;
//		return mapPanel.routeLayer && mapPanel.routeLayer.getVisibility();
//	}
//	
//	route(stops, icon, size, routeName, addPins, strokeColor, callback) {
//        var mapPanel = this;
//		//var parentPanel = me.up('panel');
//        //parentPanel.mask('Loading...');
//
//        if (!mapPanel.markerLayer) {
//            mapPanel.markerLayer = new ALKMaps.Layer.Markers("Marker Layer");
//            mapPanel.map.addLayer(mapPanel.markerLayer);
//            mapPanel.map.setLayerIndex(mapPanel.markerLayer, 2);
//        }
//
//        if (!mapPanel.routeLayer) {
//            mapPanel.routeLayer = new ALKMaps.Layer.Routing("Route Layer");
//            mapPanel.map.addLayer(mapPanel.routeLayer);
//            mapPanel.map.setLayerIndex(mapPanel.routeLayer, 1);
//        } else {
//            mapPanel.routeLayer.removeRoute(routeName);
//            mapPanel.routeLayer.setVisibility(true);
//        }
//
//        if (!mapPanel.routePins) {
//            mapPanel.routePins = {};
//        }
//        mapPanel.routePins[routeName] = [];
//
//        var stops = [];
//        var stopBackup = [];
//
//        for (var i = 0; i < stops.length; i++) {
//            stops.push(new ALKMaps.LonLat(stops[i].longitude, stops[i].latitude));
//            stopBackup.push(new ALKMaps.LonLat(stops[i].longitude, stops[i].latitude));
//        }
//        stops = ALKMaps.LonLat.transformArray(stops, new ALKMaps.Projection("EPSG:4326"), mapPanel.map.getProjectionObject());
//        stopBackup = ALKMaps.LonLat.transformArray(stopBackup, new ALKMaps.Projection("EPSG:4326"), mapPanel.map.getProjectionObject());
//
//        mapPanel.commonIcon = icon;
//        mapPanel.commonSize = size;
//
//        mapPanel.routeLayer.addRoute({
//            stops: stopBackup,
//            functionOptions: {
//                routeId: routeName,
//                style: {
//                    strokeColor: strokeColor ? strokeColor : '#00FF00',
//                    strokeWidth: 2,
//                    strokeOpacity: 1
//                },
//                showHandles: false,
//                callback: function(results) {
//                    //parentPanel.unmask();
//                    if (callback) {
//                        callback();
//                    }
//
//                    if (mapPanel.legendHTML) {
//                        mapPanel.createLegend(mapPanel.legendHTML, stops[0]);
//                        mapPanel.legendHTML = undefined;
//                    }
//
//                    if (!addPins) {
//                        return;
//                    }
//
//                    for (var i = 0; i < stops.length; i++) {
//                        var myIcon = icon;
//                        var mySize = size;
//
//                        if (i === 0) {
//                            myIcon = ALKMaps.IMAGE.FLAG_START;
//                            mySize = {
//                                width: 24,
//                                height: 24
//                            };
//                        } else if (i === stops.length - 1) {
//                            myIcon = ALKMaps.IMAGE.FLAG_END;
//                            mySize = {
//                                width: 24,
//                                height: 24
//                            };
//                        }
//
//                        var iconTruck = new ALKMaps.Icon(myIcon ? myIcon : ALKMaps.IMAGE.TRUCK_GREEN, new ALKMaps.Size(mySize ? mySize.width : 24, mySize ? mySize.height : 24));
//
//                        var mkrTruck = new ALKMaps.Marker(
//                            new ALKMaps.LonLat(stops[i].lon, stops[i].lat),
//                            iconTruck.clone(),
//                            null, // Set label text to null in order not to show default label.
//                            {
//                                map: mapPanel.map,
//                                eventListeners: {
//                                    // Show popup when click on the marker icon
//                                    "markerclick": function(evt) {
//                                        //me.map.addPopup(this.popup, true);
//                                        //this.popup.show();
//                                        return false; // In order to cancel default marker over event handler
//                                    }
//                                }
//                            }
//                        );
//
//                        mapPanel.markerLayer.addMarker(mkrTruck);
//                        
//                        if(mapPanel.routePins && mapPanel.routePins[routeName]) {
//                            mapPanel.routePins[routeName].push(mkrTruck);
//                        }
//                    }
//                }
//            },
//            routeOptions: mapPanel.routingOptions ? mapPanel.routingOptions : {
//                'highwayOnly': false
//            },
//            reportOptions: {}
//        });		
//	}
//	
//	clearEntities() {
//		var mapPanel = this;
//		
//        if (mapPanel.markerLayer) {
//            mapPanel.markerLayer.clearMarkers();
//        }
//
//        if (mapPanel.routeLayer) {
//
//            for (var i = 0; mapPanel.routeLayer.routeHandleLookup && i < mapPanel.routeLayer.routeHandleLookup.length; i++) {
//                var routeName = mapPanel.routeLayer.routeHandleLookup[i].routeId;
//                if (routeName) {
//                    mapPanel.routeLayer.removeRoute(routeName);
//                    mapPanel.routePins[routeName] = [];
//                }
//            }
//        }		
//	}
	
};
customElements.define('dl-map-panel', MapPanel);
